import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Droplets, ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ProductsSection() {
  const {
    t
  } = useLanguage();
  const [openProduct, setOpenProduct] = useState<number | null>(0);
  const products = [{
    image: 'https://cdn.magicpatterns.com/uploads/heqzLNZzetts8fzzg9iNz6/LORENA_PRODUCTOS.png',
    name: t('products', 'p1Name'),
    tagline: t('products', 'p1Tagline'),
    desc: t('products', 'p1Desc'),
    howTo: t('products', 'p1HowTo'),
    ingredients: t('products', 'p1Ingredients'),
    sizes: '50 ml  ·  100 ml  ·  200 ml'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/opqojXqtNMqHWeEBLhDkG6/RADIANCEM.png',
    name: t('products', 'p2Name'),
    tagline: t('products', 'p2Tagline'),
    desc: t('products', 'p2Desc'),
    includes: t('products', 'p2Includes'),
    ingredients: t('products', 'p2Ingredients'),
    sizes: ''
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/p8Xi157woZydcg5iD3HxtR/PREMIUN.png',
    name: t('products', 'p3Name'),
    tagline: t('products', 'p3Tagline'),
    desc: t('products', 'p3Desc'),
    includes: t('products', 'p3Includes'),
    ingredients: t('products', 'p3Ingredients'),
    sizes: ''
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8K4xyFnXUx67ayd6PdYfBf/PURI.png',
    name: t('products', 'p4Name'),
    tagline: t('products', 'p4Tagline'),
    desc: t('products', 'p4Desc'),
    includes: t('products', 'p4Includes'),
    ingredients: t('products', 'p4Ingredients'),
    sizes: ''
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/qYkK2RaB9oB1capu7wk9ng/SPECIAL_PRODUCTS.png',
    name: 'Special Products',
    tagline: 'Magic Eye Crème & Beauty Secret Moistration',
    desc: 'Productos especiales formulados con ácido hialurónico, vitaminas y emolientes para todo tipo de piel. Magic Eye Crème combate arrugas y líneas de expresión, mientras que Beauty Secret proporciona hidratación profunda para pieles deshidratadas.',
    includes: 'Magic Eye Crème · Beauty Secret Moistration',
    ingredients: 'Hyaluronic acid, vitamins, emollients, peptides',
    sizes: ''
  }];
  return <section id="productos" className="py-10 bg-white" data-id="element-356">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-357">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-358">
          <div className="flex justify-center mb-6" data-id="element-359">
            <img src="https://cdn.magicpatterns.com/uploads/jYmD6asbvXQTBHDRJHXdMo/LOGO_DE_LORENA_BEAUTY.png" alt="Lorena Beauty Skin Care" className="h-28 md:h-40 w-auto object-contain" data-id="element-360" />
          </div>
          <div className="flex items-center justify-center space-x-3 mb-2" data-id="element-361">
            <Droplets className="w-5 h-5 text-gold" data-id="element-362" />
            <span className="text-sm font-medium text-gold uppercase tracking-widest" data-id="element-363">
              {t('products', 'badge')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-3" data-id="element-364">
            {'Lorena Beauty Skin Care'}
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-3" data-id="element-365"></div>
          <p className="text-lg text-dark/70 max-w-2xl mx-auto leading-relaxed" data-id="element-366">
            {t('products', 'desc')}
          </p>
        </motion.div>

        <div className="space-y-10" data-id="element-367">
          {products.map((product, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className={`grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center ${index % 2 === 1 ? 'lg:direction-rtl' : ''}`} data-id="element-368">
              {/* Product Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-369">
                <div className="relative overflow-hidden rounded-md border-2 border-gold/20 shadow-lg group p-6 flex items-center justify-center bg-beige-light" data-id="element-370">
                  <img src={product.image} alt={product.name} className="w-full max-w-md h-auto object-contain transition-transform duration-1000 ease-out group-hover:scale-105 mix-blend-multiply" data-id="element-371" />
                  {/* Gold corner accents */}
                  <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tl-md" data-id="element-372"></div>
                  <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tr-md" data-id="element-373"></div>
                  <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-bl-md" data-id="element-374"></div>
                  <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-br-md" data-id="element-375"></div>
                </div>
              </div>

              {/* Product Info */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-376">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-dark mb-2" data-id="element-377">
                  {product.name}
                </h3>
                <p className="text-gold-dark font-medium text-lg mb-3 italic" data-id="element-378">
                  {product.tagline}
                </p>

                {product.sizes && <div className="inline-flex items-center bg-beige px-4 py-2 rounded-full border border-gold/20 mb-3" data-id="element-379">
                    <span className="text-sm font-medium text-dark/70" data-id="element-380">
                      {product.sizes}
                    </span>
                  </div>}

                <p className="text-dark/80 leading-relaxed mb-4" data-id="element-381">
                  {product.desc}
                </p>

                {/* Expandable details */}
                <div className="space-y-2" data-id="element-382">
                  {/* How to use / Includes */}
                  <div className="border border-gold/15 rounded-sm overflow-hidden" data-id="element-383">
                    <button onClick={() => setOpenProduct(openProduct === index ? null : index)} className="w-full px-5 py-3 text-left flex justify-between items-center bg-beige-light/50 focus:outline-none" data-id="element-384">
                      <span className="font-bold text-dark text-sm" data-id="element-385">
                        {product.howTo ? t('products', 'howToLabel') : t('products', 'includesLabel')}
                      </span>
                      <ChevronDown className={`w-4 h-4 text-gold transition-transform duration-300 ${openProduct === index ? 'rotate-180' : ''}`} data-id="element-386" />
                    </button>
                    <AnimatePresence data-id="element-387">
                      {openProduct === index && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3
                  }} data-id="element-388">
                          <div className="px-5 pb-4 pt-2 text-dark/70 text-sm border-t border-gold/10" data-id="element-389">
                            {product.howTo || product.includes}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>

                  {/* Ingredients */}
                  <div className="border border-gold/15 rounded-sm overflow-hidden" data-id="element-390">
                    <button onClick={() => setOpenProduct(openProduct === index + 10 ? null : index + 10)} className="w-full px-5 py-3 text-left flex justify-between items-center bg-beige-light/50 focus:outline-none" data-id="element-391">
                      <span className="font-bold text-dark text-sm" data-id="element-392">
                        {t('products', 'ingredientsLabel')}
                      </span>
                      <ChevronDown className={`w-4 h-4 text-gold transition-transform duration-300 ${openProduct === index + 10 ? 'rotate-180' : ''}`} data-id="element-393" />
                    </button>
                    <AnimatePresence data-id="element-394">
                      {openProduct === index + 10 && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3
                  }} data-id="element-395">
                          <div className="px-5 pb-4 pt-2 text-dark/70 text-sm border-t border-gold/10" data-id="element-396">
                            {product.ingredients}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}